import { Component, ViewChild } from '@angular/core';
import { Events, Nav, Platform, ToastController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Keyboard } from '@ionic-native/keyboard';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthProvider } from '../providers/auth/auth.provider';
import { UserProvider } from '../providers/user/user.provider';
import { Storage } from '@ionic/storage';

import { TabsPage } from '../pages/tabs/tabs';
import { TranslateService } from '@ngx-translate/core';
import { WelcomePage } from '../pages/welcome/welcome';
import { PresentationPage } from '../pages/presentation/presentation';
// import { AccountPage } from '../pages/account/account';
// import { LoginPage } from '../pages/login/login';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage:any = WelcomePage;
  initialized = false;

  constructor(
    public afAuth: AngularFireAuth,
    private platform: Platform, 
    private toastCtrl: ToastController,
    public statusBar: StatusBar,
    public events: Events,
    public storage: Storage,
    private keyboard: Keyboard,
    private splashScreen: SplashScreen,
    private authProvider: AuthProvider,
    private translate: TranslateService,
    public userProvider: UserProvider) {
    this.isUserLoggedIn();
    this.initializeApp();
    this.listenToEvents();
  }
  
  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleLightContent();
      this.translate.setDefaultLang('fr');
      this.splashScreen.hide();
      this.keyboard.hideFormAccessoryBar(true);
    });
  }

  async isUserLoggedIn() {
    // console.log("isUserLoggedIn");
    this.afAuth.authState.subscribe(user => {
      if (!user) {
        console.log("isUserLoggedIn : A");
        this.authProvider.setConnected(false);
        if(this.initialized)
          this.nav.setRoot(TabsPage);
        else
          this.initialized = true;
      } else {
        this.userProvider.checkUserAccount(user)
        .then((userHaveAccount) => {
          // console.log("userHaveAccount",userHaveAccount);
          if(userHaveAccount){
            console.log("isUserLoggedIn : B");
            this.authProvider.setConnected(true);
            this.nav.setRoot(TabsPage);
          } else {
            console.log("isUserLoggedIn: C",this.nav.length());
            this.userProvider.createUser();
            this.authProvider.setConnected(true);
            if(this.initialized)
              this.nav.setRoot(TabsPage);
            else
              this.initialized = true;
              // this.nav.setRoot(TabsPage, { 'authenticatedUser': user });
          }
        })
      }
    });
  }

  listenToEvents() {
    this.events.subscribe('user:login', () => { 
      // console.log("listenToEvents : user:login");
      // this.nav.pop();
      this.nav.setRoot(TabsPage);
    });
    this.events.subscribe('user:logout', () => {
      // console.log("listenToEvents : user:logout");
      // this.storage.clear();
      this.authProvider.doLogout().then(_ => {
        this.userProvider.setUser(null);
        this.nav.setRoot(PresentationPage);
      });
    });

    this.events.subscribe('message:show', (messageStr, styleClass) => {
      console.log("listenToEvents : message:show");
      let toast = this.toastCtrl.create({
        message: messageStr,
        cssClass: styleClass,
        duration: 4000,
        position: 'bottom'
      });

      toast.present();
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts